import React, { HTMLAttributes } from 'react';
import { TLazyIconKey } from '../../../../utilities/iconLoader/FontAwesomeIcon';

export namespace TopBarTypes {
  export interface ITopBarData extends HTMLAttributes<HTMLDivElement> {
    hideOnMobileDevice: boolean;
    closeButton: TLazyIconKey;
    showAnnouncementBar: boolean;
    locationType: TLocationTypes;
    ctaText?: string;
    locations: TLocations;
    iconsConfig: TIconsConfig;
    syrasoftEmailID?: string;
    variant: TVariantModes;
    theme: TThemeModes;
    buttonsConfig: TButtonsConfig;
    announcementInfo: string;
    onSetTopBarHeight?: React.Dispatch<React.SetStateAction<number>>;
  }
  export type TThemeModes = 'light' | 'dark';
  export type TLocations = {
    location: TLocation;
  };
  export type TLocation = {
    id: string;
    socialIcons: TIconsType[];
    contactDetails: TContactDetails;
  };
  export type TTopBarVariantDetails = {
    contactDetails: TContactDetails;
    redirectDetails: TRedirectDetails;
    iconsList: TIconsList;
  };
  export type TPayRentIcons = {
    onClick?: React.MouseEventHandler<HTMLDivElement>;
  };
  export type TIconsType = {
    iconName: TLazyIconKey;
    iconsUrl: string;
  };

  export interface IconBaseProps extends React.SVGAttributes<SVGElement> {
    children?: React.ReactNode;
    size?: string | number;
    color?: string;
    title?: string;
  }
  export type TIconType = (props: IconBaseProps) => JSX.Element;

  export type TLocationTypes = 'single' | 'multi';

  export type TButtonsConfig = {
    text: 'Pay Rent' | string;
    iconName: TLazyIconKey;
    show: boolean;
    showOnTouchDevice: boolean;
    url: string;
  };
  export type TIconsConfig = {
    phoneNumberIcon: TLazyIconKey;
    emailIDIcon: TLazyIconKey;
    facilityAddressIcon: TLazyIconKey;
    mailingAddressIcon: TLazyIconKey;
  };
  export type TFacilityDetails = {
    facilityAddress: string;
    googleMapsUrl: string;
    facilityName: string;
    data?: string;
  };
  export type TGenericFacilityDetails = {
    variant: TVariantModes;
    facilityDetailsType: TContactDetailsType;
    data: any;
    iconsList: TIconsList;
    redirectDetails: TRedirectDetails;
    contactDetails: TContactDetails;
  };
  export interface IFacilityGenericInfo {
    data: TFacilityDetails;
    email: string;
    mailAddress: string;
    phone: string;
  }

  export type TFacilityDetailsHelper = {
    iconsList: TIconsList;
    contactDetails: TContactDetails;
    variantType: TVariantModes;
  };
  export type TFacilityDetailsAddress = TFacilityDetailsHelper & {
    data: TFacilityDetails;
  };
  export type TFacilityDetailsEmail = TFacilityDetailsHelper & {
    email: string;
    redirectDetails: TRedirectDetails;
  };
  export type TFacilityDetailsMailingAddress = TFacilityDetailsHelper & {
    mailAddress: string;
    redirectDetails?: TRedirectDetails;
  };
  export type TFacilityDetailsPhone = TFacilityDetailsHelper & {
    phone: string;
    redirectDetails: TRedirectDetails;
  };
  export type TFacilityDetailsRedirectDetails = TFacilityDetailsHelper & {
    redirectDetails: TRedirectDetails;
  };
  export type TFacilityDetailsInfo = TFacilityDetailsHelper & {
    data?: TFacilityDetails;
    email?: string;
    mailAddress?: string;
    phone?: string;
    redirectDetails?: TRedirectDetails;
  };
  export type TContactDetailsType =
    | 'address'
    | 'email'
    | 'mailingAddress'
    | 'phone';
  export type TCommonFacilityDetails = {
    contactDetailsInfo: TFacilityDetails | string;
    contactDetails: TContactDetails;
    iconsList: TIconsList;
    redirectDetails: TRedirectDetails;
    contactDetailsType: TContactDetailsType;
    variantType: TVariantModes;
  };
  export type TContactDetails = {
    mailingAddress: string;
    emailID: string;
    phoneNumber: string;
    facilityDetails: TFacilityDetails;
  };
  export type TVariantModes = 'topbar-1' | 'topbar-2' | 'topbar-3' | 'topbar-4';

  export type TIconsList = {
    AddressIcon: TLazyIconKey;
    EmailIcon: TLazyIconKey;
    MailingAddressIcon: TLazyIconKey;
    PhoneNumberIcon: TLazyIconKey;
  };

  export type TRedirectDetails = {
    emailIDRedirect: string;
    phoneNumberRedirect: string;
  };

  export type TContactDetailsforIcons = {
    locations: TLocations;
    EmailIcon: TLazyIconKey;
    emailIDRedirect: string;
    width: number;
    children?: React.ReactNode;
    buttonsConfig: TButtonsConfig;
  };
  export type TTopBarVariantDataType = {
    width: number;
    iconsList: TIconsList;
    contactDetails: TContactDetails;
    redirectDetails: TRedirectDetails;
    contactDetailsforIcons: TContactDetailsforIcons;
    locationtype: TLocationTypes;
    buttonsConfig: TButtonsConfig;
    ctaText?: string;
    variant: string;
  };
}
